// hooks/useProgressLineActivityListData.ts
import { getProgressLineActivity } from '@api/services/analytics.service';
import { getAllUserSigninLogs } from '@api/services/sign-in.service';
import useDataQuery from '@hooks/use-data-query';
import { useMemo, useState, useCallback } from 'react';

const useSignInLogsListData = (startDate: string, endDate: string) => {
    const [search, setSearch] = useState('');

    const changeSearch = useCallback((val: string) => {
        setSearch(val);
    }, []);

    const query = useDataQuery(['users', 'sing-in', 'logs', startDate, endDate], () =>
        getAllUserSigninLogs(startDate, endDate)
    );

    const allData = query.data || [];

    const filteredData = useMemo(() => {
        if (!search) return allData;
        return allData.filter((item: any) => item.caption?.toLowerCase().includes(search.toLowerCase()));
    }, [allData, search]);

    return {
        data: filteredData,
        isLoading: query.isLoading,
        search,
        changeSearch,
    };
};

export default useSignInLogsListData;
